import { render, staticRenderFns } from "./GlobalSearchLegacy.vue?vue&type=template&id=56c8f2d7&scoped=true"
import script from "./GlobalSearchLegacy.vue?vue&type=script&lang=js"
export * from "./GlobalSearchLegacy.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchLegacy.vue?vue&type=style&index=0&id=56c8f2d7&prod&lang=css"
import style1 from "./GlobalSearchLegacy.vue?vue&type=style&index=1&id=56c8f2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8f2d7",
  null
  
)

export default component.exports